export enum TicketMarketStatus {
  OPEN,
  CANCELLED,
  WINNING,
  LOSING,
}

export enum BuyTicketStep {
  APPROVE_SWAP,
  SWAP,
  APPROVE_BUY,
  BUY,
  COMPLETED,
}

export enum TicketAction {
  EXERCISE,
  CANCEL,
  MARKLOST,
}
